import React, { useState, useEffect, useContext, useRef, use } from "react";
import { MobileView,isMobile } from "react-device-detect";
import ItemInPanier from "./ItemPanier";
import {useFetch} from "../../api/FetchApiData";
import Select from "react-select";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Paypal from "./paypal/Paypal";
import { Rating } from "react-simple-star-rating";
import { useNavigate } from "react-router-dom";
import { MediaUrl } from "../../utils/Media";
import panierIcon from '../../icons/panier.png';
import cashIcon from '../../icons/cash.png';
import deliveryIcon from '../../icons/delivry.png';
import creditIcon from '../../icons/cartebleu.jpg';
import dixmilleIcon from '../../icons/10000.png';
import infoIcon from '../../icons/info_icon.jpg';
import home_icon from '../../map/icons/home.png';

if (isMobile)
    import('./panier_mob.css').then(() => {});
else
    import('./panier.css').then(() => {});

export default function Panier({User,setUser})
{
    const [panier,setPanier] = useState({prices:{total:0,delivery:0},articles:[],delivers:[]});
    const [addresses,setAddresses] = useState([]);
    const [mes_addresses, setMesAddresses] = useState([]);
    const [selAddress,setSelAddress] = useState(null);
    const orArticlesRef = useRef([]);
    const [mapContex,setMapContext] = useState({display:'block',btnText:'-',loading:false,points:[]});    
    const refCashPaymentBtn = useRef(null);
    const navigator = useNavigate();

    const fetchData = useFetch();
    
    const PartnerOption = (location,is_partner=false)=>{
        if(!is_partner)
        {
            return(
            <div key={location.label} className="select-option" style={{fontSize:'small'}}>
                <img src={home_icon} style={{margin:'auto',width:'30px',height:'30px',verticalAlign:'middle',borderRadius:'15px',display:'inline-block'}} />
                <div style={{display:'inline-block',width:'82%',verticalAlign:'middle',textAlign:'center'}}>
                    <label>{location.label}</label><br/>
                    <span style={{color:'rgb(120,120,120)',fontSize:'xx-small'}}>{location.display_name}</span>
                </div>
            </div>);
        }
        else
        {
            return(
                <div key={location.name} style={{fontSize:'small'}}>
                    <div style={{display:'inline-block',verticalAlign:'middle',maxWidth:'50px'}}>
                        <div style={{margin:'auto',marginBottom:'-6px'}}>
                            <img src={MediaUrl(location.logo.image)} style={{margin:'auto',width:'28px',height:'28px',borderRadius:'15px'}} />
                        </div>
                        <Rating st initialValue={location.note} size={8} style={{}} />
                    </div>
                    <div style={{display:'inline-block',width:'77%',verticalAlign:'middle',textAlign:'center'}}>
                        <label>{location.name}</label><br/>
                        <label style={{color:'gray',fontSize:'xx-small'}}>{location.address.display_name}</label>
                    </div>
                </div>);
        }
    }

    const PartnersOptions = (partners,key,addresse_length=0)=>
    {
        return partners.reduce((result,current)=>{
            if(!!current.address)
            {
                
                let groupKey = current[current.address.ville];
                if(groupKey===undefined)
                    groupKey = current.address.ville
                const index = result.findIndex(item=>item.label===groupKey);
                if(index===-1)
                {
                    result.push({label:groupKey,options:[{value:current.address,partner_id:current.id,label:PartnerOption(current,true)}]});
                    if(!!panier.delivery_address && current.address.id===panier.delivery_address)
                    {
                        setSelAddress(result[result.length-1].options[0]);
                    }
                }
                else
                {
                    result[index].options.push({value:current.address,partner_id:current.id,label:PartnerOption(current,true)});
                    if(!!panier.delivery_address && current.address.id===panier.delivery_address)
                    {
                        setSelAddress(result[index].options[result[index].options.length-1]);
                    }
                }
            }
            return result;
        },[])
    }

    const LoadPartners = async ()=>{
        let arr = [];
        let index = 0;
        arr.push({label:'Mes Addresses',options:[]});
        User.locations.forEach(element => {
            arr[arr.length-1].options.push({value:element,label:PartnerOption(element,false)});
            index++;
            if(!!panier.delivery_address && element.id===panier.delivery_address)
            {
                setSelAddress(element);
            }
        });
        setMesAddresses([...arr]);
        await fetchData.PostData({},'partners/filter/all/').then((result)=>{
            if(result.result)
            {
                arr = [...arr,...PartnersOptions(result.partners,'ville',arr.length)];
            }
        })
        setAddresses([...arr]);
        setMapContext({...mapContex,points:[...arr]});
    }

    const UpadateAddresses = (CashPaymentMode = false)=>
    {
        try{
        if(CashPaymentMode)
        {
            mes_addresses.map(ad=>{
                const index_ = addresses.indexOf(ad);
                if(index_!==-1)
                    addresses.splice(index_,1);
            });
            if(selAddress.value.type==='user_point')
                setSelAddress(null);
        }
        else
        {
            mes_addresses.map(ad=>{
                if(!addresses.includes(ad))
                    addresses.push(ad)
            });
        }
        setAddresses([...addresses]);
        }
        catch{}
    }

    const is_ready_to_checkout = ()=>
    {
        for (let i=0;i<panier.articles.length;i++)
        {
            const article = panier.articles[i];
            if(article.deliver===null || article.deliver===undefined)
                return false;
            if(article.is_location && (article.location_dates.length===0))
                return false;
        }
        return true;
    }

    useEffect(()=>{
        fetchData.GetData('panier/').then((result)=>{
            if(result.result)
                setPanier({...panier});
        })
        LoadPartners();
    },[]);

    useEffect(()=>{
        addresses.forEach((element)=>{
            element.options.forEach((option)=>{
                if(!!panier.delivery_address && option.value.id===panier.delivery_address)
                {
                    setSelAddress(option);
                }
            });
        })
    },[addresses, panier.delivery_address])


    const SaveAddress = async(address)=>{
        let _panier = {'id':panier.id, articles:panier.articles,delivery_address:address};
        if(!!panier.partner)
            _panier = {..._panier, partner:panier.partner};
        await fetchData.PutData(_panier,'panier/').then((result)=>{
            if(result.result)
                setPanier({...result.panier});
        });
    }

    const SaveDeliver = async(deliver)=>{
        const _panier = {'id':panier.id, articles:panier.articles,deliver:deliver};
        await fetchData.PutData(_panier,'panier/').then((result)=>{
            if(result.result)
                setPanier({...result.panier});
        });
    }

    useEffect(()=>{
        if(refCashPaymentBtn.current!==null)
            refCashPaymentBtn.current.value = panier.prices.total;
    },[panier.prices.total])

    useEffect(()=>{
        SaveDeliver(panier.deliver);
    },[panier.deliver])

    useEffect(()=>{
        SaveAddress(panier.delivery_address);
    },[panier.delivery_address])
    

    const InfoCash = ()=>
    {
        if(panier.prices.total>1000)
            return("Pour les montants supérieurs à 1000 euros Vous devez payer au minimum la moitié du prix de votre commande. Pour cela, choisissez le montant que vous voulez régler aujourd'hui puis générer votre ticket de paiement. Contactez nous par télephone au 07xxxxx ensuite pour confiramer votre commande ou par via votre messagerie.");
        else
            return("Veuillez génerer votre ticket de commande puis contacter nous par télephone au 07xxxxx ou via votre messagerie pour confirmer votre commande")
    }

    const OrderCash = ()=>
    {
        fetchData.PostData({mode:'cash', articles:orArticlesRef.current},'payment/').then((result)=>{
            if(result.result)
            {
                navigator(`/payment/cash/result/${result.order_id}`);
            }
        })
    }

    return(
        <div id="Panier">
            <div id="Panier-Container">
                <MobileView>
                    <div className="panier-title">
                        <img style={{width:'30px'}} src={panierIcon}/>
                        <span style={{fontWeight:'bold'}}>Vos Articles</span>
                    </div>
                </MobileView>
                {
                    panier.articles.map((item,index)=>{
                        return <ItemInPanier orArticlesRef={orArticlesRef} deliver={panier.deliver} key={index} panier={panier} setPanier={setPanier} Item={item} />
                    })
                }
            </div>
            <div id="PaymentBlock">
                <fieldset style={{borderRadius:'5px'}} id="DelivryBlock">
                    <div className="panier-title" style={{borderTopLeftRadius:'5px',borderTopRightRadius:'5px'}}>
                        <img src={deliveryIcon}/>
                        <span>Livraison</span>
                    </div>             
                    <div className="w-64 mx-auto mt-5" style={{marginTop:'10px',width:'90%',margin:'auto'}}>
                        <label className="delivery-label" style={{color:'gray'}}>Addresse :</label>
                        <div className="delivery-select" style={{textAlign:'center'}}>
                            <Select 
                                value={selAddress}
                                isClearable 
                                options={addresses}
                                styles={{menuPortal:(base)=>({...base, zIndex:9999})}} 
                                onChange={(value,action)=>{setPanier({...panier,delivery_address:value.value['id'],partner:value.partner_id});setSelAddress(value);}}   
                            />
                        </div>
                    </div>            
                    <div className="delivery-price" style={{marginTop:'auto',marginTop:'10px',textAlign:'center'}}>
                        <span>Livraison pour : <b><span>{panier.prices.delivery} €</span></b></span>
                    </div>   
                </fieldset>
                {is_ready_to_checkout() && 
                <fieldset id="PaymentInfo">
                    <div className="panier-title">
                        <img src={cashIcon}/>
                        <span>Paiement</span>
                    </div>
                    <Tabs style={{width:'90%',margin:'auto',marginTop:'10px'}}>
                        <TabList style={{width:'100%'}}>
                            <Tab style={{width:'40%'}} onClick={e=>{UpadateAddresses(false);}}>
                                <div style={{padding:'0px 5px 0px 5px'}}>
                                    <img style={{width:'30px',padding:'5px',borderRadius:'5px', display:'inline-block',verticalAlign:'middle'}} src={creditIcon}/>
                                    <span style={{display:'inline-block',verticalAlign:'middle',fontSize:'small'}}>Carte</span>
                                </div>
                            </Tab>
                            <Tab style={{width:'40%'}} onClick={e=>{UpadateAddresses(true);}}>                            
                                <div style={{padding:'0px 5px 0px 5px'}}>
                                    <img style={{width:'30px',padding:'5px',borderRadius:'5px', display:'inline-block',verticalAlign:'middle'}} src={dixmilleIcon}/>
                                    <span style={{display:'inline-block',verticalAlign:'middle',fontSize:'small'}}>Cash</span>
                                </div>
                            </Tab>
                        </TabList>
                        <TabPanel>
                            <div className="PaymentInfoItem"><label>Articles : </label><span style={{float:'right'}}>{panier.prices.articles} €</span></div>
                            <div className="PaymentInfoItem"><label>Livraison : </label><span style={{float:'right'}}>{panier.prices.delivery} €</span></div>
                            <div className="PaymentInfoItem-total"><label>Total </label><span style={{float:'right'}}>{panier.prices.total} €</span></div>
                            <Paypal orArticlesRef={orArticlesRef} User={User} prices={panier.prices} />
                        </TabPanel>
                        <TabPanel>
                            <div className="PaymentInfoItem"><label>Articles : </label><span style={{float:'right'}}>{panier.prices.articles} €</span></div>
                            <div className="PaymentInfoItem"><label>Livraison : </label><span style={{float:'right'}}>{panier.prices.delivery} €</span></div>
                            <div className="PaymentInfoItem-total"><label>Total </label><span style={{float:'right'}}>{panier.prices.total} €</span></div>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyItems:'center',marginTop:'10px',margin:'auto',marginBottom:'10px'}} className="PaymentInfoItem">
                                <img src={infoIcon} className="cash-info-icon" />
                                <div className="panier-info-cash">
                                    <span>{InfoCash()}</span>
                                </div>
                            </div>
                            <div className="PaymentInfoItem" style={{margin:'auto',marginTop:'15px'}}>
                                    <label style={{display:'inline-block', fontWeight:'bold'}}>1ere Paiement (€) : </label>
                                    <div style={{display:'inline-block',maxWidth:'20%',marginLeft:'20px'}}>
                                        <input ref={refCashPaymentBtn} type="number" disabled={panier.prices.total<1000} style={{padding:'2px 5px 3px 5px',extAlign:'center',fontWeight:'bold',width:'60px',verticalAlign:'middle'}} min={panier.prices.total/2} max={panier.prices.total} defaultValue={panier.prices.total} />
                                    </div>
                            </div>
                            <input onClick={e=>{OrderCash()}} className="btn-payment" type="button" value={"Ticket de Commande"}  />
                        </TabPanel>
                    </Tabs>
                </fieldset>}
            </div>
        </div>);
}